export default {
  alerts: {
    id: 'listings_alerts',
    defaultMessage: 'Alerts',
  },
  market: {
    id: 'listings_market',
    defaultMessage: 'Market',
  },
  marketsAlerts: {
    id: 'listings_market_alerts',
    defaultMessage: 'Markets alerts',
  },
  isDisabled: {
    id: 'listings_warning_is_disabled',
    defaultMessage: 'The listing is disabled',
  },
  missingPriceOrComment: {
    id: 'listings_warning_missing_price_or_comment',
    defaultMessage: 'Missing price or comment',
  },
  missingPrice: {
    id: 'listings_warning_missing_price',
    defaultMessage: 'Missing price',
  },
  awaitingValidation: {
    id: 'listings_warning_awaiting_validation',
    defaultMessage: 'Awaiting validation',
  },
  isOffline: {
    id: 'listings_warning_is_offline',
    defaultMessage: 'This listing is offline',
  },
  hasNonCompliantDeliveryMethods: {
    id: 'listings_warning_has_non_compliant_delivery_methods',
    defaultMessage:
      "This listing's shipping configuration is non-compliant. The listing must have a free home delivery shipping method, and if collection points are set up, a free collection point shipping method.",
  },
  missingShipping: {
    id: 'listings_warning_missing_shipping',
    defaultMessage: 'Missing shipping method',
  },
  noStock: {
    id: 'listings_warning_no_stock',
    defaultMessage: 'This listing has no stock available',
  },
  isLimited: {
    id: 'listings_warning_limited',
    defaultMessage: 'This listing has reached its limitation',
  },
  missingFreeShipping: {
    id: 'listings_warning_missing_free_shipping',
    defaultMessage: 'Missing a free shipping method',
  },
  missingFreeHomeDeliveryShipping: {
    id: 'listings_warning_missing_free_home_delivery_shipping',
    defaultMessage: 'Missing a free home delivery shipping method',
  },
  missingFreeCollectionPointShipping: {
    id: 'listings_warning_missing_free_collection_point_shipping',
    defaultMessage: 'Missing a free collection point delivery shipping method',
  },
  isPriceLowerThanMin: {
    id: 'listings_warning_is_price_lower_than_min',
    defaultMessage: 'Price too low',
  },
  isPriceHigherThanMax: {
    id: 'listings_warning_is_price_higher_than_max',
    defaultMessage: 'The price is above the new price: {price}',
  },
  isLimitedOnGrade: {
    id: 'listings.warning.is_limited_on_grade',
    defaultMessage: "You can't sell this grade",
  },
  addFreeShippingMethod: {
    id: 'listings_add_free_shipping',
    defaultMessage: 'Add a free shipping method',
  },
  noAlerts: {
    id: 'listings_alerts_no_conditions',
    defaultMessage: 'You do not have any alerts for this listing',
  },
  fetchingData: {
    id: 'listings_alerts_fetching_data',
    defaultMessage: 'We are fetching the data...',
  },
  isProductNotPending: {
    id: 'listings_alerts_is_product_not_pending',
    defaultMessage: 'Product has enough information to be validated',
  },
  isProductNotRejected: {
    id: 'listings_alerts_is_product_not_rejected',
    defaultMessage: 'Following charter rules this product can be sold',
  },
  isRestrictedOnCategory: {
    id: 'listings_alerts_is_restricted_on_category',
    defaultMessage: 'This category is restricted to specific sellers',
  },
  allMarkets: {
    id: 'listings_alerts_all_markets',
    defaultMessage: 'All',
  },
  goToInsights: {
    id: 'listings_alerts_go_to_insights',
    defaultMessage: 'Go to Insights',
  },
  aestheticSuspensionDescription: {
    id: 'listings_alerts_aesthetic_suspension_description',
    defaultMessage:
      "We've suspended sales of this category due to your Appearance Rate.",
  },
  defectiveSuspensionDescription: {
    id: 'listings_alerts_defective_suspension_description',
    defaultMessage:
      "We've suspended sales sales of this model until {formattedEndDate} due to your Defective Rate.",
  },
}
